export default class SetResult {
  constructor(homeScore = 0, awayScore = 0) {
    this.homeScore = homeScore;
    this.awayScore = awayScore;
  }
}